<template>
  <div class="kt-header__topbar-item admin-link-holder">
    <div v-if="user.is_super_admin">
      <a href="/admin" class="btn btn-ss-standout">
        <i class="flaticon2-cardiogram" />
        <span>Admin</span>
      </a>
    </div>

    <div v-if="can_revert_to_admin">
      <a href="/user/revert-to-admin" class="btn btn-ss-standout ml-2">
        <i class="flaticon2-cardiogram" />
        <span>Revert to Admin</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: window.user,
      revert_to_admin: window.revert_to_admin,
    };
  },
  computed: {
    can_revert_to_admin() {
      return this.revert_to_admin?.user_name;
    },
  },
  methods: {
    revertToAdmin() {
      axios.post('/api/v1/tools/revert-to-admin').then(() => {
        window.location.href = "/admin";
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .admin-link-holder {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: 44px;
    cursor: pointer;
    margin-right:1em;
  }
</style>
